<template>
  <div class="ts-space-y-4">
    <div class="row">
      <div class="col-md-7">
        <form class="form-horizontal ts-space-y-3">
          <div class="row">
            <label class="col-md-3 col-form-label ts-text-xs required ts-font-light">{{ $t('promotion.eventName')
            }}</label>
            <div class="col-md-8">
              <input v-model="model.promotion_name" type="text" class="form-control" />
              <div class="validate ts-text-xs" v-if="errors.has('promotion_name')">{{ errors.first('promotion_name')
              }}</div>
            </div>
          </div>
          <div class="row">
            <label class="col-md-3 col-form-label ts-text-xs required ts-font-light">{{ $t('promotion.startDate')
            }}</label>
            <div class="col-md-8">
              <a-date-picker v-model="model.promo_start_date" class="ts-w-full" format="DD-MM-YYYY"
                valueFormat="DD-MM-YYYY"></a-date-picker>
              <div class="validate ts-text-xs" v-if="errors.has('promo_start_date')">{{
                errors.first('promo_start_date') }}</div>
            </div>
          </div>
          <div class="row">
            <label class="col-md-3 col-form-label ts-text-xs"></label>
            <div class="col-md-8">
              <ts-checkbox v-model="model.is_no_end_date" class="ts-font-light"
                @change="() => model.promo_end_date = null">{{ $t('promotion.tillFurtherNotice') }}</ts-checkbox>
            </div>
          </div>
          <div class="row">
            <label class="col-md-3 col-form-label ts-text-xs ts-font-light"
              :class="!model.is_no_end_date ? 'required' : null">{{ $t('promotion.endDate') }}</label>
            <div class="col-md-8">
              <a-date-picker v-model="model.promo_end_date" :disabled="model.is_no_end_date" class="ts-w-full"
                format="DD-MM-YYYY" valueFormat="DD-MM-YYYY"></a-date-picker>
              <div class="validate ts-text-xs" v-if="errors.has('promo_end_date')">{{ errors.first('promo_end_date')
              }}</div>
            </div>
          </div>
        </form>
      </div>
      <div class="col-md-5">
        <div class="ts-w-10/12 ts-h-full ts-border ts-border-gray-300 ts-rounded-md ts-p-3">
          <BranchList v-model="model" />
          <div class="validate ts-text-xs" v-if="errors.has('branch_id_list')">{{ errors.first('branch_id_list') }}
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <ScheduleDay v-model="model" :validate="errors" />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <IncentiveByItemCondition v-model="model" :validate="errors" />
        <div class="validate ts-text-xs" v-if="errors.has('condition')">
          {{ errors.first('condition') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 ts-flex ts-items-center ts-space-x-3 ts-justify-end">
        <ts-button @click.prevent="$router.push({ name: 'promotion' })">
          {{ $t('cancel') }}
        </ts-button>
        <ts-button v-if="!isEdit" color="primary" outline :waiting="loading" @click.prevent="onSaveAddNew">
          {{ $t('save_add_new') }}
        </ts-button>
        <ts-button v-if="!isEdit" :waiting="loading" @click.prevent="onSave" color="primary">
          {{ $t('save') }}
        </ts-button>
        <ts-button v-if="isEdit" color="primary" :waiting="loading" @click.prevent="onUpdate">
          {{ $t('update') }}
        </ts-button>
      </div>
    </div>
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import BranchList from './branch-list'
import IncentiveByItemCondition from './incentive-by-item-condition'
import ScheduleDay from './schedule_day'
import { isEmpty } from 'lodash'

export default {
  name: 'incentiveByItem',
  components: {
    BranchList,
    IncentiveByItemCondition,
    ScheduleDay
  },
  data() {
    return {
      loading: false,
      errors: new Errors(),
      model: {
        promotion_name: '',
        promo_type_id: 5,
        is_no_end_date: false,
        promo_start_date: '',
        promo_end_date: '',
        branch_id_list: [],
        promo_schedule_list: [],
        condition: []
      }
    }
  },
  created() {
    this.createDay()
    this.getPreData({
      params: {},
      index: undefined
    })
  },
  computed: {
    ...mapState('promotion/incentiveByItem', ['edit_data']),
    isEdit() {
      return !_.isEmpty(this.edit_data)
    },
  },
  methods: {
    ...mapActions('promotion/incentiveByItem', ['getFormViewModel', 'store', 'update']),
    async getPreData({ params, index }) {
      this.loading = true
      await this.getFormViewModel({ index: index, params: params })
        .catch(error => {
          this.notice({ type: 'error', text: error.message })
        })
        .finally(() => (this.loading = false))
    },
    onSave() {
      this.loading = true
      this.errors = new Errors()
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'promotion' })
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onSaveAddNew() {
      this.loading = true
      this.errors = new Errors()
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onUpdate() {
      this.loading = true
      this.errors = new Errors()
      this.update({
        id: this.$route.params.id,
        data: this.model
      })
        .then(response => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'promotion' })
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    },
    createDay() {
      this.model.promo_schedule_list = []
      for (var i = 1; i <= 7; i++) {
        this.model.promo_schedule_list.push({
          day_id: null,
          time_from: null,
          time_to: null
        })
      }
    },
    setEditData() {
      if (!isEmpty(this.edit_data)) {
        this.model.promotion_name = this.edit_data.promotion_name
        this.model.promo_type_id = this.edit_data.promo_type_id
        this.model.is_no_end_date = this.edit_data.is_no_end_date
        this.model.promo_start_date = this.edit_data.promo_start_date
        this.model.promo_end_date = this.edit_data.promo_end_date
        this.model.branch_id_list = this.edit_data.branches.map(el => el.branch_id)
        this.model.condition = this.edit_data.condition.map(el => ({
          promotion_id: el.promotion_id,
          product_id: el.product_id,
          currency_id: el.currency_id,
          input_currency_id: el.input_currency_id,
          fx_rate: el.fx_rate,
          fx_rate_ratio: el.fx_rate_ratio,
          discount_type: el.discount_type,
          discount_rate: el.discount_rate,
          input_discount_rate: el.input_discount_rate,
          incentive_type: el.incentive_type,
          incentive_rate: el.incentive_rate,
          input_incentive_rate: el.input_incentive_rate,
        }))

        this.model.promo_schedule_list = []

        for (var i = 1; i <= 7; i++) {
          this.model.promo_schedule_list.push({
            day_id: this.edit_data.schedules.filter(d => d.day_id == i).reduce((i, v) => i = v.day_id, null),
            time_from: this.edit_data.schedules.filter(d => d.day_id == i).reduce((i, v) => i = v.time_from, null),
            time_to: this.edit_data.schedules.filter(d => d.day_id == i).reduce((i, v) => i = v.time_to, null),
            order: i
          })
        }

        this.model.promo_schedule_list = _.orderBy(this.model.promo_schedule_list, ['order'], ['asc'])
      }
    },
    clearInput() {
      this.model.promotion_name = ''
      this.model.promo_type_id = 5
      this.model.is_no_end_date = false
      this.model.promo_start_date = ''
      this.model.promo_end_date = ''
      this.model.branch_id_list = []
      this.model.condition = []
      this.model.promo_schedule_list.forEach(element => {
        element.day_id = null
        element.time_from = null
        element.time_to = null
      });
    }
  }
}
</script>